import React, { useState } from "react";
import "./ECLPassword.css";
import { ECLThemeImage } from "../../index";
import { translate } from "../../../utilities/Translate";
/*
 * Props
 * password - state value
 * setPassword - state value setter function
 * placeholder - text that will display in the placeholder
 * id - unique id used for switching the eye-ball image
 * pattern - A regular expression that the input's value must match for the value to pass constraint validation. (ex. pattern="[0-9]{3}")
 * */
export default function ECLPassword({
   password,
   setPassword,
   placeholder,
   id,
   pattern,
   className,
}) {
   const [passwordHidden, setPasswordHidden] = useState(true);

   const handleChange = (e) => {
      //not sure we usually want to be setting the password and updating state every time the user types
      //might want to just handle with getElementById() on a submitted form?
      setPassword(e.target.value);
   };

   return (
      <div className={"ecl-password"}>
         <label htmlFor={id} style={{ display: "none" }}>
            {placeholder !== undefined ? placeholder : "Password"}
         </label>
         <input
            pattern={pattern && pattern}
            type={passwordHidden ? "password" : "text"}
            value={password && password}
            onChange={setPassword && handleChange}
            placeholder={placeholder !== undefined ? placeholder : "Password"}
            className={className}
            id={id}
            required={true}
         />
         <button
            className="ecl-password-button"
            onClick={(e) => {
               e.preventDefault();
               setPasswordHidden(!passwordHidden);
            }}
            type="button"
         >
            {passwordHidden ? (
               <ECLThemeImage
                  alt={translate("Show password")}
                  fontAwesome="eye"
               />
            ) : (
               <ECLThemeImage
                  alt={translate("Hide password")}
                  fontAwesome="eye-slash"
               />
            )}
         </button>
      </div>
   );
}
